import { useSelector, useDispatch } from 'react-redux';
import { myAccountSelector } from 'state/selectors/account';
import { patchAccount } from 'state/callers';
import cloneDeep from 'lodash/cloneDeep';
import { STEPS_ORDER } from 'components/UserProfileWizard/Steps/steps.consts';
import { organizationSelector } from 'state/selectors/organization';

const useUserProfile = () => {
  const dispatch = useDispatch();
  const { extra = {}, id: accountId } = useSelector(myAccountSelector) || {};
  const { id: orgId } = useSelector(organizationSelector) ?? {};
  const today = new Date();
  const todayParsed = today.toISOString().split('T')[0];

  const userProfileDBData = cloneDeep(extra?.userProfileData || {});
  const snoozeValue = userProfileDBData?.snoozeWizardTill
    ? userProfileDBData?.snoozeWizardTill.split('T')[0]
    : userProfileDBData?.snoozeWizardTill;

  // finds the index of the step the user is currently on
  const currentStepIndex = userProfileDBData?.currentStep
    ? STEPS_ORDER.indexOf(userProfileDBData.currentStep)
    : 0;

  // if snooze is undefined or equal to today and doNotShowAgain = false or undefined
  const shouldShowWizard =
    (todayParsed === snoozeValue || !snoozeValue) &&
    !userProfileDBData?.doNotShowAgain;

  const onSave = async data => {
    const payload = {
      extra: {
        ...extra,
        userProfileData: { ...userProfileDBData, ...data }
      }
    };

    try {
      await patchAccount(accountId, payload)(dispatch);
    } catch (e) {
      return e;
    }
  };

  return {
    onSave,
    userProfileDBData,
    shouldShowWizard,
    currentStepIndex,
    accountId,
    orgId
  };
};

export default useUserProfile;
